<div class="modal-header col-head">
  <!-- <img [src]="universityData?.summaryData?.collegeProfileIcon" /> -->
  <div class="virtue-logo d-flex">
    <img
      *ngIf="universityData?.summaryData?.imageAvailable"
      [src]="universityData?.summaryData?.collegeProfileIcon"
    />
    <!-- [ngClass]="AddHypen ? 'addhypen' : ''" -->
    <span
      *ngIf="universityData?.summaryData?.imageAvailable == false"
      id="randomcolors"
      [style.backgroundColor]="universityData?.summaryData?.defaultLabelColor"
    >
      {{ getFirstAndLastWords(universityData?.dropDownData?.name) }}
    </span>

    <!-- <ng-container *ngIf="universityData?.summaryData?.imageAvailable" ;>
      <img [src]="universityData?.summaryData?.collegeProfileIcon" />
    </ng-container>
    <ng-container *ngIf="universityData?.summaryData?.imageAvailable == false">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="#f26722"
        style="
          display: inline-block;
          margin-right: 8px;
          width: 24px;
          border-radius: 50%;
          position: relative;
          right: 10px;
          transform: scale(1.5);
        "
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z"
        />
      </svg>
    </ng-container> -->
    <h2>
      {{ universityData.dropDownData.name }}

      <br />
      <span
        class="college-Rank"
        style="float: left"
        *ngIf="universityData?.dropDownData?.collegeRankInUS"
      >
        Rank: {{ universityData?.dropDownData?.collegeRankInUS }}</span
      >
    </h2>
  </div>

  <button
    type="button"
    class="close pull-right"
    aria-label="close"
    (click)="close()"
  >
    <span aria-hidden="true">×</span>
  </button>
</div>

<div class="row mt-4 px-3">
  <!-- <p *ngIf="isGridDataUsed" style="color: green;">
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="w-6 h-6"
    style="
      display: inline-block;
      width: 17px;
      color: rgb(52, 170, 52);
    "
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
    />
  </svg>
    The grants for this college is calculated using  grant data for in-state students, actual grants may vary.
  </p> -->
  <div class="col" *ngIf="universityData?.summaryData?.cssProfileEFC">
    <!-- <h2>CSS Profile EFC</h2> -->
    <div class="css-stamp">
      CSS Profile SAI:
      <span class="text-success font-weight-bold">
        {{
          universityData.summaryData.cssProfileEFC
            ? (universityData.summaryData.cssProfileEFC
              | currency : "$ " : "symbol" : "1.0-0")
            : "-"
        }}
      </span>
    </div>
  </div>
  <div class="col text-right">
    <div class="stamp">
      Time Stamp:
      <span>
        {{
          universityData.summaryData.dataCollectionTime | date : "MM-dd-yyyy"
        }}</span
      >
    </div>
  </div>
</div>
<div class="row mt-4 px-3">
  <p *ngIf="isGridDataUsed" class="info-merit">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      class="w-6 h-6"
      style="display: inline-block; width: 17px; color: rgb(52, 170, 52)"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
      />
    </svg>
    <!-- The grants for this college are calculated using  grant data for in-state students, actual grants may vary. -->
    The Merit & Gift Aid for this college are calculated using grant data for
    <u>in-state</u> students, actual Merit & Gift Aid may vary for out-state
    students.
  </p>
</div>
<div class="modal-body pt-2 col-details">
  <div class="row">
    <div class="col">
      <div class="click-here">
        The Scholarship Estimator is updated regularly but we encourage students
        to review the college website. If you find any discrepancy please let us
        know through our feedback form
        <a (click)="openFeedBackForm()">(Click here)</a>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col describe">
      <!-- <h3>College Summary</h3> -->
      <ul>
        <li>
          Academic Year:
          <span>{{
            universityData.summaryData.lastSupportedSession
              ? universityData.summaryData.lastSupportedSession
              : "-"
          }}</span>
        </li>
        <li>
          Enrollment Type:
          <span>{{
            universityData?.summaryData?.enrollmentType === "FOUR_YEAR_PROGRAM"
              ? "4-year"
              : "2-year"
          }}</span>
        </li>

        <li>
          NPC Link:
          <span
            ><a [href]="universityData.summaryData.npcLink" target="_blank">{{
              universityData.summaryData.npcLink
            }}</a></span
          >
        </li>
        <li>
          Financial Aid Link:
          <span>
            <a
              [href]="universityData.summaryData.financialAid"
              target="_blank"
              >{{ universityData.summaryData.financialAid }}</a
            >
          </span>
        </li>
        <li *ngIf="universityData.summaryData.outStateTutionFee != ''">
          Out - State Tuition:
          <span>{{
            universityData.summaryData.outStateTutionFee
              | currency : "$ " : "symbol" : "1.0-0"
          }}</span>
        </li>
        <li *ngIf="universityData.summaryData.inStateTutionFee != ''">
          In - State Tuition:
          <span>{{
            universityData.summaryData.inStateTutionFee
              | currency : "$ " : "symbol" : "1.0-0"
          }}</span>
        </li>
        <li>
          University Contact:

          <span>{{
            SetContacFormate(universityData.summaryData.contact)
          }}</span>
        </li>
        <li>
          University Website:
          <span
            ><a [href]="universityData.summaryData.website" target="_blank">{{
              universityData.summaryData.website
            }}</a></span
          >
        </li>
        <li>
          University Address:
          <span>{{ universityData.summaryData.address }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="col-lg-12 mt-0 mb-0">
    <p class="footer-notes">
      *Room & Board and Miscellaneous Expenses data may vary from NPC for some
      housing options.
    </p>
  </div>

  <div class="col-lg-12 text-center">
    <button
      class="page-btn mt-3 text-center"
      type="button"
      aria-label="close"
      (click)="close()"
    >
      Close
    </button>
  </div>
  <!-- <div class="col-lg-12">
    <div class="text-center">
      <button type="button" (click)="close()" class="moreview btn page-btn">
        Close
      </button>
    </div>
  </div> -->
</div>
